const SUBNAV_FILTER_TYPE = {
  ALL: 'all',
  ON_MARKET: 'on-market',
  CLAIMED: 'claimed',
  // eslint-disable-next-line constellation/word-list
  OFF_MARKET: 'off-market',
  AT_RISK: 'at-risk',
  FREE_BONUS_LISTINGS: 'bonus',
  ARCHIVED: 'archived',
};

/**
 * Determine the type of layout to render for comet verticals. (applications, leases, payments, etc.)
 * We display a full view on the sense of home page.
 * We display a more simple view on the dashboard overview page.
 */
enum VERTICAL_DISPLAY_TYPE {
  FULL = 'FULL',
  SIMPLE = 'SIMPLE',
}

const PropertiesConstants = {
  PROPERTIES_ACTIVE_DEFAULT: true,
  PROPERTIES_INACTIVE_DEFAULT: true,
  PROPERTIES_SEARCHTEXT_DEFAULT: '',
  PROPERTIES_START_KEY_EXCLUSIVE_DEFAULT: '',
  PROPERTIES_LIMIT_DEFAULT: 12,
  PROPERTIES_MULTIPLEX_LIMIT_DEFAULT: 24,
  PROPERTIES_INCLUDE_FEED_CLAIM_AND_CONVERT_UPDATE: true,
  PROPERTIES_UNVERIFIED_EMAIL_FEED_LIMIT: 5,
  PROPERTIES_INCLUDE_ARCHIVED: false,
  PROPERTIES_INCLUDE_UNARCHIVED: true,
  PROPERTIES_INCLUDE_AT_RISK: false,
  PROPERTIES_INCLUDE_FREE_BONUS_LISTINGS_ONLY: false,
  PROPERTIES_INCLUDE_FREE_CLAIMED_LISTINGS_ONLY: false,
  PROPERTIES_INCLUDE_TOURS: false,
  PROPERTIES_INCLUDE_CONTACT_COUNT: false,

  PROPERTIES_SUBNAV_FILTER_TYPE: SUBNAV_FILTER_TYPE,
  PROPERTIES_SUBNAV_FILTER_OPTIONS: [
    /**
     * @param {boolean} [id] - ID of the tab
     * @param {boolean} [includeActive] - Include active listings
     * @param {boolean} [includeInactive] - Include inactive listings
     * @param {String} [label] - Label of the button
     * @param {Number} [count] - Number display after the label
     * */
    {
      id: SUBNAV_FILTER_TYPE.ALL,
      label: 'All',
      includeActive: true,
      includeFreeClaimedListingsOnly: false,
      includeInactive: true,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: false,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.ON_MARKET,
      label: 'For rent',
      includeActive: true,
      includeFreeClaimedListingsOnly: false,
      includeInactive: false,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: false,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.CLAIMED,
      label: 'Claimed',
      includeActive: false,
      includeFreeClaimedListingsOnly: true,
      includeInactive: false,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: false,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.OFF_MARKET,
      // eslint-disable-next-line constellation/word-list
      label: 'Off-market',
      includeActive: false,
      includeFreeClaimedListingsOnly: false,
      includeInactive: true,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: false,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.AT_RISK,
      label: 'At-risk',
      includeActive: false,
      includeFreeClaimedListingsOnly: false,
      includeInactive: false,
      includeAtRisk: true,
      includeFreeBonusListingsOnly: false,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.FREE_BONUS_LISTINGS,
      label: 'Bonus',
      includeActive: false,
      includeFreeClaimedListingsOnly: false,
      includeInactive: false,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: true,
      includeArchived: false,
      includeUnarchived: true,
      count: 0,
    },
    {
      id: SUBNAV_FILTER_TYPE.ARCHIVED,
      label: 'Archived',
      includeActive: true,
      includeFreeClaimedListingsOnly: false,
      includeInactive: true,
      includeAtRisk: false,
      includeFreeBonusListingsOnly: false,
      includeArchived: true,
      includeUnarchived: false,
      count: 0,
    },
  ],
};

export { VERTICAL_DISPLAY_TYPE };

export default PropertiesConstants;
